module.exports = __webpack_public_path__ + "media/images/main/hero/hero-bd7bc819a76e0bfd780fae547dbc1f6f.png";